module.exports = __webpack_public_path__ + "static/lionjumperhamper-b8277d78f652389fac7fda0596abe6c1.jpeg";